var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        visible: _vm.visible,
        "append-to-body": "",
        width: "60%",
        title: "活动奖品",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "el-button",
        {
          attrs: {
            type: "primary",
            icon: "el-icon-plus",
            size: "mini",
            disabled: _vm.recordList.length === 8,
          },
          on: {
            click: function ($event) {
              return _vm.handleAdd("prize")
            },
          },
        },
        [_vm._v("新增奖品")]
      ),
      _c(
        "el-button",
        {
          attrs: {
            type: "primary",
            icon: "el-icon-plus",
            size: "mini",
            disabled: _vm.recordList.length === 8,
          },
          on: {
            click: function ($event) {
              return _vm.handleAdd("none")
            },
          },
        },
        [_vm._v("新增谢谢参与")]
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.recordList,
            border: "",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            key: "index",
            attrs: {
              label: "序号",
              type: "index",
              width: "50",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.$index + 1) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖品名称", prop: "prizeName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "奖品价值", prop: "price", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "数量（已中奖量/奖品库存量）", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 4
                      ? _c("div", [_vm._v("-")])
                      : _c("div", [
                          _vm._v(
                            _vm._s(scope.row.winNumbers || 0) +
                              "/" +
                              _vm._s(scope.row.stockNumbers || 0)
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "中奖概率", prop: "winnerRate", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(scope.row.winnerRate.toFixed(2) + "%")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "排序", prop: "sort", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#d9001b" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDel(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c("prize-edit", {
        ref: "prizeEdit",
        attrs: {
          visible: _vm.showEdit,
          prizeType: _vm.prizeType,
          activityId: _vm.activityId,
          activeStatus: _vm.activeStatus,
        },
        on: { close: _vm.editClose, init: _vm.editSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }